import axios from "axios";
import { API_URL } from "./axioscontants";

let timerId = null;
const TIMEOUT_MS = 120 * 1000; // 120 seconds (adjust)

export const startActiveTimer = (onTimeout) => {
  var notifyServer = localStorage.getItem("activestatus");
  clearActiveTimer();
  timerId = setTimeout(() => {
    onTimeout();
  }, TIMEOUT_MS);
  if (notifyServer === "away") {
    console.log("User is active again, notifying server...");
    notifyActiveRestarted();
  }
};

export const resetActiveTimer = (onTimeout) => {
  startActiveTimer(onTimeout);
};

export const clearActiveTimer = () => {
  if (timerId) {
    clearTimeout(timerId);
    timerId = null;
  }
};


export const notifyActiveTimeout = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    if (!userData) return;

    await axios.post(
      `${API_URL}/session/activestatus/${userData.qhoid}/${userData.qhuid}/away`,
      { _ignoreLoading: true } // ⬅️ IMPORTANT
    );
    localStorage.setItem("activestatus", "away");
    console.warn("⏰ Session timeout notified");
  } catch (err) {
    console.error("Failed to notify timeout", err);
  }
};

export const notifyActiveRestarted = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("userDetails"));
    if (!userData) return;

    await axios.post(
      `${API_URL}/session/activestatus/${userData.qhoid}/${userData.qhuid}/online`,
      { _ignoreLoading: true } // ⬅️ IMPORTANT
    );
    localStorage.setItem("activestatus", "online");
    console.warn("⏰ Session restarted notified");
  } catch (err) {
    console.error("Failed to notify restart", err);
  }
};
